import { aaguids } from '@treezor/treezor-sca';

import { getDuration } from '@/utils/tools/DateTools';
import { ISupportUser } from '@/features/dashboard-users/store/support-user.model';

export const useDashboardUserInformation = (dashboardUser: ISupportUser) => {
  const isBlocked = dashboardUser?.wrongPwdAttempts >= 3;
  const client = dashboardUser?.clients?.[dashboardUser.clients.length - 1];
  const lastLogin = client?.lastLoginAt ? getDuration(new Date(client.lastLoginAt)) : undefined;
  const creationDate = client?.acceptedAt ? new Date(client.acceptedAt) : undefined;
  const accessExpirationDate = dashboardUser?.accessExpirationDate
    ? new Date(dashboardUser?.accessExpirationDate)
    : undefined;

  const secureKey = dashboardUser?.secureKey;

  const hasSecureKey = !!secureKey && (typeof secureKey === 'object' ? Object.keys(secureKey).length > 0 : !!secureKey);

  const transports = hasSecureKey
    ? aaguids[secureKey.authenticator?.aaguid]?.name || secureKey.authenticator?.aaguid
    : undefined;

  const secureKeyCreatedDate = hasSecureKey ? new Date(secureKey.createdDate) : undefined;

  return {
    isBlocked,
    lastLogin,
    creationDate,
    hasSecureKey,
    transports,
    secureKeyCreatedDate,
    accessExpirationDate,
  };
};
